import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';

function App() {

    const [orderData, setorderData] = useState('');
    const userId = sessionStorage.getItem("TRCUserId");

    const getOrders = async () => {
        const data ={userId: userId}
		try {
			const response = await axios.post('https://api.trucoo.in/orders/orders/', data,  {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			console.log(response.data);
			if(response.data.status === 'success'){
				setorderData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};


	useEffect(() => {
		getOrders();
	},[]);

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
			<div class="box">
				<div class="box-header with-border">
				  <h4 class="box-title">All Orders</h4>
				  <p class="mb-0 box-subtitle">All Order Data</p>
				</div>
				<div class="box-body">
					<div class="table-responsive">
					  <table id="example" class="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
						<thead>
							<tr class="text-dark">
								<th>S.No</th>
								<th>Date</th>
								<th>Order ID</th>
								<th>Location</th>
								<th>Items</th>
								<th>Order Total</th>
								<th>Advance Payment</th>
								<th>Client</th>
								<th>Delivery Date</th>
								<th>Status</th>
								<th>View More</th>
								
							</tr>
						</thead>
						<tbody>
							{orderData.length > 0 ? orderData.map((order, index) =>
							<tr key={index}>
								<td class="text-dark">{index+1}</td>
								<td>{order.orderDate}</td>
								<td>{order.orderId}</td>
								<td>{order.location}</td>
								<td>{order.items}</td>
								<td>{Number(order.totalPayment).toFixed(2)}</td>
								<td>{Number(order.advancePayment).toFixed(2)}</td>
								<td>{order.clientData.name} - <small>{order.clientData.companyName}</small></td>
                                <td>{order.deliveryDate}</td>
                                <td>{order.status}</td>
                                <td>
                                    <a href={`/order-details?id=${order.orderId}`} class="form-control" style={{textAlign: 'center'}}>View</a>
                                </td>
								
							</tr>
							):(
								<tr>
									<td colSpan={6}>No Orders</td>
								</tr>
							)}
							
						</tbody>	
					</table>
					</div>              
				</div>
			  </div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;